import React from 'react';

export default function TabelaDesvios({ dados }) {
  return (
    <div className="max-h-64 overflow-y-auto border border-gray-300 rounded-md">
      <table className="min-w-full">
        <thead className="bg-gray-200 sticky top-0">
          <tr>
            <th className="px-4 py-2 border-b text-left">Desvio</th>
            <th className="px-4 py-2 border-b text-left">Equipamento</th>
            <th className="px-4 py-2 border-b text-left">Compartimento</th>
            <th className="px-4 py-2 border-b text-left">Observação</th>
          </tr>
        </thead>
        <tbody>
          {dados && dados.length > 0 ? (
            dados.map((item, index) => (
              <tr key={index} className="hover:bg-gray-100">
                <td className="px-4 py-2 border-b">{item.desvio}</td>
                <td className="px-4 py-2 border-b">{item.eqp}</td>
                <td className="px-4 py-2 border-b">{item.comp}</td>
                <td className="px-4 py-2 border-b">{item.obs}</td>
              </tr>
            ))
          ) : (
            <tr>
              <td
                colSpan="3"
                className="px-4 py-2 border-b text-center text-gray-500"
              >
                Nenhum dado disponível
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}
